import React, { Component } from 'react';
import { connect } from 'react-redux';
import { crossDomainNavigation } from '../../redux/modules/app';
import i18n from 'kodyl-js/i18n/react';
import { authFacebook } from '../../profile/redirection';

@connect(
  () => ({}),
  { crossDomainNavigation }
)
@i18n
class FacebookLoginButton extends Component {
  submit = () => {
    this.props.crossDomainNavigation();
  };

  render() {
    return (
      <a
        href={authFacebook()}
        onClick={this.submit}
        className="btn btn-block btn-facebook"
      >
        <i
          className="fa fa-facebook"
          style={{
            marginRight: '0.5em',
            width: '1.28571429em',
            textAlign: 'center'
          }}
        />
        {this.i18n('Login with %s', 'Facebook')}
      </a>
    );
  }
}

export default FacebookLoginButton;
